query Statistics($companyId: String!, $isMasterView: Boolean, $childCompanyId: ID) {
  statistics(companyId: $companyId, isMasterView: $isMasterView, childCompanyId: $childCompanyId) {
    totalLeadValue
    totalValuationCount
    totalCommissionValue {
      value
      commission
    }
    totalLeadCount {
      total
      withValuation
      lastThirtyDays
    }
    totalLeadCountByStatus {
      new
      unreached
      newWithValuation
    }
    totalTrafficSource {
      count
      type
    }
  }
}
